import { render, staticRenderFns } from "./selectLanguage.vue?vue&type=template&id=7955efbf&scoped=true&"
import script from "./selectLanguage.vue?vue&type=script&lang=js&"
export * from "./selectLanguage.vue?vue&type=script&lang=js&"
import style0 from "./selectLanguage.vue?vue&type=style&index=0&id=7955efbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955efbf",
  null
  
)

export default component.exports